import { render, staticRenderFns } from "./horizontal-nav.vue?vue&type=template&id=9b4db556&scoped=true&lang=pug&"
import script from "./horizontal-nav.vue?vue&type=script&lang=js&"
export * from "./horizontal-nav.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-nav.vue?vue&type=style&index=0&id=9b4db556&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4db556",
  null
  
)

export default component.exports